import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vdss',
  templateUrl: './vdss.component.html',
  styleUrls: ['./vdss.component.sass']
})
export class VdssComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
